import { useContext } from "react"
import { Form } from 'antd';
import Context from '../../../context/appContext';


export default function ReadOnlyField({ info }) {
    const { dataForm: { hiddenFields } } = useContext(Context);

    return (
        <Form.Item
            label={''}
            name={info.key}
            hidden={hiddenFields[info.key]}
        >
            <p className='ant-text'>
                <td dangerouslySetInnerHTML={{ __html: info.content ? info.content : '' }} />
            </p>
        </Form.Item>
    )
}